import { useTranslation } from 'react-i18next';

import { DateUtils } from 'utils/DateUtils';
import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { WithTestId } from 'types/app';

import { Complaint } from '@Atomic/organisms/Complaint';
import { Text } from '@Atomic/atoms/Text';

import styles from './style.module.scss';

type Props = WithTestId<{
  id: number;
  publishedAt: number;
}>;

export const OfferComplaint = ({ id, publishedAt, testId }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.complaint}>
      <div>
        <div
          className={`${styles.row} ${styles.offerId}`}
          data-testid={getTestIdByParts(testId, 'number')}
        >
          <Text className={styles.label}>{t('offer.number')}</Text>
          <Text>{id}</Text>
        </div>
        <div className={styles.row} data-testid={getTestIdByParts(testId, 'time')}>
          <Text className={styles.label}>{t('offer.publicationTime')}</Text>
          <Text>{DateUtils.format(publishedAt, 'DD.MM.YYYY, HH:mm')}</Text>
        </div>
      </div>

      <Complaint testId={getTestIdByParts(testId, 'complaint')} />
    </div>
  );
};
